import { HTMLAttributeReferrerPolicy } from 'react'

export function getHoverChartUrl(ticker: string, escaped: boolean = false): string {
  let imgUrl = `${FinvizSettings.nodeChartsDomain}/chart.ashx?cs=m&t=${ticker}&tf=${
    FinvizSettings.stocksHoverChartTimeframe || 'd'
  }&ct=candle_stick`
  if (FinvizSettings.hasUserPremium && FinvizSettings.stocksHoverChartPatterns) {
    imgUrl +=
      '&o[0][ot]=sma&o[0][op]=50&o[0][oc]=FF8F33C6&o[1][ot]=sma&o[1][op]=200&o[1][oc]=DCB3326D&o[2][ot]=patterns&o[2][op]=&o[2][oc]=000'
  }
  if (escaped) {
    // "Escaping" [ and ] because of how boxover.js works
    imgUrl = imgUrl.replace(/\[/g, '[[').replace(/]/g, ']]')
  }
  return imgUrl
}

export function getHoverChartDimensions() {
  switch (FinvizSettings.stocksHoverChartTimeframe) {
    case 'i3':
    case 'i15':
      return { width: 584, height: 180 }
    case 'i5':
      return { width: 376, height: 180 }
    case 'd':
      if (FinvizSettings.stocksHoverChartPatterns) return { width: 464, height: 230 }
      return { width: 324, height: 180 }
    default:
      return { width: 324, height: 180 }
  }
}

export function getReferrerPolicy(): HTMLAttributeReferrerPolicy {
  return 'no-referrer-when-downgrade'
}

export function getHoverChartImg(ticker: string, escaped: boolean = false) {
  const referrerPolicy = getReferrerPolicy()
  const { width, height } = getHoverChartDimensions()
  const url = getHoverChartUrl(ticker, escaped)
  const srcSet = getSrcSet(url)
  const srcsetString = srcSet?.length ? `srcset='${srcSet}'` : ''

  return {
    img: `<img referrerPolicy='${referrerPolicy}' ${srcsetString} src='${url}' width='${width}' height='${height}' />`,
    width,
    height,
  }
}

export function getSrcSet(url: string) {
  return FinvizSettings.hasUserRetinaHoverCharts ? `${url} 1x, ${url}&sf=2 2x` : undefined
}
